import { ApolloClient, InMemoryCache, createHttpLink, Observable } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { queryClient } from './react-query'
import { refreshToken as refreshTokenService } from 'services/auth.service'

const httpLink = createHttpLink({
  uri: `${process.env['REACT_APP_GRAPHQL_URL']}`,
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken')

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  }
})

const errorLink = onError(({ graphQLErrors, networkError, forward, operation, response }: any) => {
  if (graphQLErrors) {
    return forward(operation)
  }
  if (networkError) {
    if (networkError.statusCode === 403) {
      const expiredLogin = localStorage.getItem('expiredLogin')
      const dateNow = new Date().getTime()

      // If user not check remember me much check time for handle call api refresh token
      if (!expiredLogin || parseInt(expiredLogin) > dateNow) {
        const refreshToken = localStorage.getItem('refreshToken')
        const retryObservable = new Observable((subscriber) => {
          if (subscriber.closed || !refreshToken) {
            return
          }
          refreshTokenService(refreshToken)
            .then((result: any) => {
              if (!result || result?.data?.res_code === '98') {
                operation.setContext({
                  response: {
                    errors: null,
                  },
                })
                localStorage.clear()
                client.clearStore()
                queryClient.clear()
                location.reload()
              } else {
                const token = result?.data
                if (token.accessToken) {
                  localStorage.setItem('accessToken', token.accessToken)
                  localStorage.setItem('refreshToken', token.refreshToken)

                  const oldHeaders = operation.getContext().headers
                  operation.setContext({
                    headers: {
                      ...oldHeaders,
                      authorization: `Bearer ${token.accessToken}`,
                    },
                  })
                  subscriber.next(operation)
                  subscriber.complete()
                }
              }
            })
            .catch(() => {
              localStorage.clear()
              client.clearStore()
              queryClient.clear()
              location.reload()
              return
            })
        })
        return retryObservable.flatMap((newOperation: any) => forward(newOperation as any))
      } else {
        localStorage.clear()
        location.reload()
      }
    }
  }
})

const client = new ApolloClient({
  link: authLink.concat(errorLink).concat(httpLink),
  cache: new InMemoryCache(),
})

export { client }
